// // src/api/searchApi.js

// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/search_products`;

// export const searchProducts = async (query, page_size = 10, page_token = '') => {
//   try {
//     const response = await fetch(API_URL, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ query, page_size, page_token }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     if (!data.products || !Array.isArray(data.products)) {
//       throw new Error('Invalid response format: missing products array');
//     }

//     const records = data.products.map(p => ({
//       article_id: p.id,
//       prod_name: p.title,
//       price: p.price,
//       image_uri: p.image?.trim(),
//       currency: p.currency || 'USD',
//       detail_desc: p.detail_desc || p.description || 'No description available.' // Map description
//     }));

//     return {
//       records,
//       next_page_token: data.next_page_token || ''
//     };
//   } catch (error) {
//     console.error('Search API Error:', error);
//     if (error.message.includes('Failed to fetch')) {
//       throw new Error('Network error: Unable to connect to search server.');
//     }
//     throw error;
//   }
// };

// src/api/searchApi.js

// src/api/searchApi.js

// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/search_products`;

// export const searchProducts = async (query, page_size = 10, page_token = '') => {
//   try {
//     const response = await fetch(API_URL, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ query, page_size, page_token }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     if (!data.products || !Array.isArray(data.products)) {
//       throw new Error('Invalid response format: missing products array');
//     }

//     // Map product records
//     const records = data.products.map(p => ({
//       article_id: p.id,
//       prod_name: p.title,
//       price: p.price,
//       image_uri: p.image?.trim(),
//       currency: p.currency || 'USD',
//       detail_desc: p.description || 'No description available.'
//     }));

//     return {
//       records,
//       next_page_token: data.nextPageToken || '',
//       totalSize: data.totalSize || 0,
//       correctedQuery: data.correctedQuery || '' // Fix: correct key name
//     };
//   } catch (error) {
//     console.error('Search API Error:', error);
//     if (error.message.includes('Failed to fetch')) {
//       throw new Error('Network error: Unable to connect to search server.');
//     }
//     throw error;
//   }
// };

//chnages

// src/api/searchApi.js
// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/search_products`;
// const PRODUCT_DETAIL_URL = `https://us-central1-retail-jkommerce-poc.cloudfunctions.net/detail_page_view`;

// export const searchProducts = async (
//   query,
//   page_size = 10,
//   page_token = ""
// ) => {
//   try {
//     const response = await fetch(API_URL, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ query, page_size, page_token }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     if (!data.products || !Array.isArray(data.products)) {
//       throw new Error("Invalid response format: missing products array");
//     }

//     // Map product records
//     const records = data.products.map((p) => ({
//       article_id: p.id,
//       prod_name: p.title,
//       price: p.price,
//       image_uri: p.image?.trim(),
//       currency: p.currency || "USD",
//       detail_desc: p.description || "No description available.",
//     }));

//     return {
//       records,
//       next_page_token: data.nextPageToken || "",
//       totalSize: data.totalSize || 0,
//       correctedQuery: data.correctedQuery || "",
//       attributionToken: data.attributionToken || "", // Add attribution token from response
//     };
//   } catch (error) {
//     console.error("Search API Error:", error);
//     if (error.message.includes("Failed to fetch")) {
//       throw new Error("Network error: Unable to connect to search server.");
//     }
//     throw error;
//   }
// };

// // New API function to get product details using attribution token
// export const getProductDetails = async (productId, attributionToken) => {
//   try {
//     const response = await fetch(PRODUCT_DETAIL_URL, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         product_id: productId,
//         attributionToken: attributionToken, // Fixed: using correct parameter name
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     // Transform the response to match our product format while preserving all data
//     return {
//       id: data.product_id || productId,
//       name: data.primary_product?.title || data.title || "Product Name",
//       price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       original_price: parseFloat(data.variants?.[0]?.original_price || data.primary_product?.price || data.price || 0),
//       discounted_price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       image: (data.variants?.[0]?.images?.[0]?.trim() || 
//               data.primary_product?.images?.[0]?.trim() || 
//               "").replace("storage.cloud.google.com", "storage.googleapis.com"),
//       currency: data.variants?.[0]?.currency || data.primary_product?.currency || data.currency || "USD",
//       description: data.variants?.[0]?.description || 
//                    data.primary_product?.description || 
//                    data.description || 
//                    "No description available.",
//       // Include all original data for access to similar_products, variants, etc.
//       ...data,
//       // Preserve the attribution token for subsequent requests
//       attributionToken: attributionToken
//     };
//   } catch (error) {
//     console.error("Product Detail API Error:", error);
//     throw new Error("Failed to load product details. Please try again.");
//   }
// };



// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/search_products`;
// const PRODUCT_DETAIL_URL = `https://us-central1-retail-jkommerce-poc.cloudfunctions.net/detail_page_view`;

// export const searchProducts = async (
//   query,
//   page_size = 10,
//   page_token = ""
// ) => {
//   try {
//     const response = await fetch(API_URL, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ query, page_size, page_token }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     if (!data.products || !Array.isArray(data.products)) {
//       throw new Error("Invalid response format: missing products array");
//     }

//     // Map product records
//     const records = data.products.map((p) => ({
//       article_id: p.id,
//       prod_name: p.title,
//       price: p.price,
//       image_uri: p.image?.trim(),
//       currency: p.currency || "USD",
//       detail_desc: p.description || "No description available.",
//     }));

//     return {
//       records,
//       next_page_token: data.nextPageToken || "",
//       totalSize: data.totalSize || 0,
//       correctedQuery: data.correctedQuery || "",
//       attributionToken: data.attributionToken || "",
//       originalQuery: query,
//     };
//   } catch (error) {
//     console.error("Search API Error:", error);
//     if (error.message.includes("Failed to fetch")) {
//       throw new Error("Network error: Unable to connect to search server.");
//     }
//     throw error;
//   }
// };

// // Updated API function to handle search query flow
// export const getProductDetails = async (productId, attributionToken, searchQuery = "", isInitialCall = false, correctedQuery = "") => {
//   try {
//     // For initial call, use correctedQuery if available, otherwise use searchQuery
//     const queryToUse = isInitialCall && correctedQuery ? correctedQuery : searchQuery;
    
//     const response = await fetch(PRODUCT_DETAIL_URL, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         product_id: productId,
//         attributionToken: attributionToken,
//         correctedQuery: queryToUse,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`API Error: ${response.status}`);
//     }

//     const data = await response.json();

//     // Transform the response to match our product format while preserving all data
//     const result = {
//       id: data.product_id || productId,
//       name: data.primary_product?.title || data.title || "Product Name",
//       price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       original_price: parseFloat(data.variants?.[0]?.original_price || data.primary_product?.price || data.price || 0),
//       discounted_price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       image: (data.variants?.[0]?.images?.[0]?.trim() || 
//               data.primary_product?.images?.[0]?.trim() || 
//               "").replace("storage.cloud.google.com", "storage.googleapis.com"),
//       currency: data.variants?.[0]?.currency || data.primary_product?.currency || data.currency || "USD",
//       description: data.variants?.[0]?.description || 
//                    data.primary_product?.description || 
//                    data.description || 
//                    "No description available.",
//       // Include all original data
//       ...data,
//       // Preserve tokens and queries for subsequent requests
//       attributionToken: attributionToken,
//       searchQuery: data.search_query || queryToUse, // Use response search_query or fallback to what we sent
//       correctedQuery: correctedQuery, // Keep the correctedQuery for reference
//       isInitialCall: false // Subsequent calls are not initial
//     };
    
//     return result;
//   } catch (error) {
//     console.error("Product Detail API Error:", error);
//     throw new Error("Failed to load product details. Please try again.");
//   }
// };

import { getErrorMessage } from "../config/errorConfig";
import { getUserProfile } from "../utils/auth";
import { SEARCH_PRODUCTS_URL, DETAIL_PAGE_VIEW_URL } from "../config/apiConfig";

const API_URL = SEARCH_PRODUCTS_URL;
const PRODUCT_DETAIL_URL = DETAIL_PAGE_VIEW_URL;


export const searchProducts = async (
  query,
  page_size = 10,
  page_token = ""
) => {

   const userProfile = getUserProfile();
  const customer_id = userProfile?.customer_id;
  let visitor_id=customer_id
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, page_size, page_token,visitor_id, }),
    });

       if (!response.ok) {
      if (response.status === 404) {
        throw new Error(getErrorMessage("API_PRODUCT_NOT_FOUND"));
      } else if (response.status >= 500) {
        throw new Error(getErrorMessage("API_SERVER_ERROR"));
      } else {
        throw new Error(getErrorMessage("API_BAD_REQUEST"));
      }
    }
    const data = await response.json();

  if (!data.products || !Array.isArray(data.products)) {
      throw new Error(getErrorMessage("API_INVALID_RESPONSE_FORMAT"));
    }
    // Map product records
    const records = data.products.map((p) => ({
      article_id: p.id,
      prod_name: p.title,
      price: p.price,
      image_uri: p.image?.trim(),
      currency: p.currency || "USD",
      detail_desc: p.description || "No description available.",
    }));

    return {
      records,
      next_page_token: data.nextPageToken || "",
      totalSize: data.totalSize || 0,
      correctedQuery: data.correctedQuery || "",
      attributionToken: data.attributionToken || "",
      originalQuery: query,
    };
  } catch (error) {
    console.error("Search API Error:", error);
     if (error.message.includes("Failed to fetch")) {
      throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
    }
    throw error;
  }
};

// Fixed API function - properly extract attribution token from response
// export const getProductDetails = async (productId, attributionToken, searchQuery = "", isInitialCall = false, correctedQuery = "") => {
//   try {
//     // For initial call, use correctedQuery if available, otherwise use searchQuery
//     const queryToUse = isInitialCall && correctedQuery ? correctedQuery : searchQuery;
//        const userProfile = getUserProfile();
//   const customer_id = userProfile?.customer_id;
  
//     const response = await fetch(PRODUCT_DETAIL_URL, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         product_id: productId,
//         attributionToken: attributionToken,
//         correctedQuery: queryToUse,
//         visitor_id:customer_id,
//       }),
//     });

//       if (!response.ok) {
//       if (response.status === 404) {
//         throw new Error(getErrorMessage("API_PRODUCT_NOT_FOUND"));
//       } else if (response.status >= 500) {
//         throw new Error(getErrorMessage("API_SERVER_ERROR"));
//       } else {
//         throw new Error(getErrorMessage("API_BAD_REQUEST"));
//       }
//     }

//     const data = await response.json();
    
//     // Transform the response to match our product format while preserving all data
//     const result = {
//       id: data.product_id || productId,
//       name: data.primary_product?.title || data.title || "Product Name",
//       price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       original_price: parseFloat(data.variants?.[0]?.original_price || data.primary_product?.price || data.price || 0),
//       discounted_price: parseFloat(data.variants?.[0]?.discounted_price || data.primary_product?.price || data.price || 0),
//       image: (data.variants?.[0]?.images?.[0]?.trim() || 
//               data.primary_product?.images?.[0]?.trim() || 
//               "").replace("storage.cloud.google.com", "storage.googleapis.com"),
//       currency: data.variants?.[0]?.currency || data.primary_product?.currency || data.currency || "USD",
//       description: data.variants?.[0]?.description || 
//                    data.primary_product?.description || 
//                    data.description || 
//                    "No description available.",
//       // Include all original data
//       ...data,
//       // FIXED: Properly extract attribution token from response
//       attributionToken: data.attributionToken,
//       searchQuery: data.search_query || queryToUse,
//       correctedQuery: correctedQuery,
//       isInitialCall: false
//     };
    
//     return result;
//   } catch (error) {
//     if (error.message.includes("Failed to fetch")) {
//       throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
//     }
//       throw error;
//   }
// };




export const getProductDetails = async (productId, attributionToken, searchQuery = "", isInitialCall = false, correctedQuery = "") => {
  try {
    const queryToUse = isInitialCall && correctedQuery ? correctedQuery : searchQuery;
    const userProfile = getUserProfile();
    const customer_id = userProfile?.customer_id;
    if(customer_id===undefined){
      customer_id=null
    }

    const response = await fetch(PRODUCT_DETAIL_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        product_id: productId,
        attributionToken: attributionToken,
        correctedQuery: queryToUse,
        visitor_id: customer_id,
      }),
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error(getErrorMessage("API_PRODUCT_NOT_FOUND"));
      } else if (response.status >= 500) {
        throw new Error(getErrorMessage("API_SERVER_ERROR"));
      } else {
        throw new Error(getErrorMessage("API_BAD_REQUEST"));
      }
    }

    const data = await response.json();

    // Normalize: Handle flat structure (no primary_product/variants)
    const isFlatStructure = !data.primary_product && data.product && data.product.id;

    let productData = null;

    if (isFlatStructure) {
      const p = data.product;

      productData = {
        id: p.id,
        title: p.title,
        description: p.description,
        images: p.images?.map(url => url.trim()).filter(Boolean) || [],
        price_info: p.price_info || {},
        attributes: p.attributes || {},
        brands: p.brands || [],
        categories: p.categories || [],
        similar_products: data.similar_products || [],

        // Preserve raw data for debugging
        ...data,

        // Add attribution token from response
        attributionToken: data.attributionToken,
        searchQuery: data.search_query || queryToUse,
        correctedQuery: correctedQuery,
        isInitialCall: false
      };
    } else {
      // Legacy: Handle nested structure
      const primary = data.primary_product || {};
      const variants = data.variants || [];
      const firstVariant = variants[0] || {};

      productData = {
        id: data.product_id || productId,
        title: primary.title || firstVariant.title || "Product Title",
        description: firstVariant.description || primary.description || "No description available.",
        images: (firstVariant.images || primary.images || []).map(url => url.trim()).filter(Boolean),
        price_info: firstVariant.price_info || primary.price_info || {},
        attributes: firstVariant.attributes || primary.attributes || {},
        brands: primary.brands || [],
        categories: primary.categories || [],
        similar_products: data.similar_products || [],

        ...data,
        attributionToken: data.attributionToken,
        searchQuery: data.search_query || queryToUse,
        correctedQuery: correctedQuery,
        isInitialCall: false
      };
    }

    return productData;

  } catch (error) {
    if (error.message.includes("Failed to fetch")) {
      throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
    }
    throw error;
  }
};